<template>
  <div>
    <div class="release-idle-container">
      <div class="release-idle-container-form">
        <el-form label-width="80px">
          <el-form-item label="新闻标题:">
            <el-input
                placeholder="请输入新闻标题（5~100个字）"
                v-model="newsInfo.title"
                :disabled="type === 'info'"
                clearable>
            </el-input>
          </el-form-item>
        </el-form>
        <hr>
        <!-- 文章内容 -->
        <article class="article-content">
          <div class="content-text">
            <mavon-editor
                v-model="newsInfo.content"
                defaultOpen="preview"
                :editable="type !== 'info'"
                :subfield="type !== 'info'"
                :toolbarsFlag="type !== 'info'"
            />
          </div>
        </article>
        <br>
        <hr>
        <div style="display: flex; justify-content: space-between;">
          <div>
            <div class="release-tip">分类专栏:</div>
            <el-select v-model="newsInfo.type" placeholder="请选择类别" :disabled="type === 'info'">
              <el-option v-for="item in options2" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="release-idle-container-picture">
          <div v-if="type!=='info'" class="release-idle-container-picture-title">添加封面</div>
          <el-upload
              v-if="type!=='info'"
              action="http://www.weste-sound.com/api/file/uploadNewsPic"
              class="avatar-uploader"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="{token: token}"
          >
<!--          <el-upload
              v-if="type!=='info'"
              action="http://192.168.1.3:8091/file/uploadNewsPic"
              class="avatar-uploader"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="{token: token}"
          >-->
            <img v-if="newsInfo.image" :src="$store.state.baseApi + newsInfo.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div v-if="type==='info'" class="release-tip">
            封面:
            <img
                :src="$store.state.baseApi + newsInfo.image"
                style="width: auto; height: 140px;"
                alt="新闻封面"
            >
          </div>
        </div>
        <br>
        <hr>
        <el-input class="release-idle-detiles-text" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }"
                  placeholder="请输入文章摘要..."
                  v-model="newsInfo.summary" maxlength="200" show-word-limit
                  :disabled="type === 'info'">
        </el-input>
        <template>
          <div>
            <el-form>
              <el-form-item label="新闻标签:">
                <el-tag
                    v-for="tag in tags"
                    :key="tag"
                    closable
                    :disable-transitions="type === 'info'"
                    @close="type !== 'info' ? handleClose(tag) : null">
                  {{ tag }}
                </el-tag>
                <el-input
                    class="input-new-tag"
                    v-if="inputVisible && type !== 'info'"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm">
                </el-input>
                <el-button v-else-if="type !== 'info'" class="button-new-tag" style="padding: 5px;" @click="showInput">
                  添加标签
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <div v-if="type !== 'info'" style="display: flex;justify-content: center;margin-top: 30px;margin-bottom: 30px;">
          <el-button type="primary" plain @click="releaseButton(0)">保存草稿</el-button>
          <el-button type="primary" plain @click="releaseButton(1)">确认发布</el-button>
          <el-button type="primary" plain @click="fanhui()">返回</el-button>
        </div>
        <div v-if="type === 'info'" style="display: flex;justify-content: center;margin-top: 30px;margin-bottom: 30px;">
          <el-button type="primary" @click="toBack()" plain>返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

const TypeEnum = {
  COMPANY: '公司咨询',
  INDUSTRY: '行业新闻',
  NOTICE: '通知公告'
};

export default {
  name: "release",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  props: ["parent"],
  data() {
    return {
      token: '',
      imageUrl: '',
      options2: [],
      tags: [],
      inputVisible: false,
      inputValue: '',
      newsInfo: {
        title: '',
        content: '',
        image: '',
        summary: '',
        tagList: [],
        type: '',
        status: 0,
      },
      type: '',
      id: '',
    };
  },
  methods: {
    init(id, type) {
      if (id) {
        this.id = id;
        this.type = type;
        this.info(id);
      }
    },
    info(id) {
      this.$api.getNewsById({
        id: id
      }).then((res) => {
        if (res.code === 200) {
          this.newsInfo = res.data;
          this.tags = this.newsInfo.tagList;
        }
      })
    },
    fanhui() {
      //你确定要返回吗？
      this.$confirm('现在返回改动不会保存,你确定要返回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.toBack();
      });
    },
    toBack() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.getDataList();
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.tags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    handleAvatarSuccess(res, file) {
      /*【这个对图片进行压缩处理，临时的缩略显示】*/
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.newsInfo.image = res.data;
        this.$message({
          showClose: true,
          message: '恭喜你，上传成功✔',
          type: 'success'
        });
      }
    },
    releaseButton(val) {
      this.newsInfo.tagList = this.tags;
      this.newsInfo.status = val;
      if (this.newsInfo.title &&
          this.newsInfo.content &&
          this.newsInfo.type &&
          this.newsInfo.image) {
        this.$api.addNews(this.newsInfo).then(res => {
          if (res.code === 200) {
            if (val == 0) {
              this.$message({
                message: '保存成功！',
                type: 'success'
              });
            } else {
              this.$message({
                message: '发布成功！',
                type: 'success'
              });
            }
            this.toBack();
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        }).catch(e => {
          this.$message.error('请填写完整信息');
        })
      } else {
        let emptyFields = [];
        if (!this.newsInfo.title) {
          emptyFields.push('新闻标题');
        }
        if (!this.newsInfo.content) {
          emptyFields.push('新闻内容');
        }
        if (!this.newsInfo.type) {
          emptyFields.push('分类专栏');
        }
        if (!this.newsInfo.image) {
          emptyFields.push('新闻封面');
        }
        if (emptyFields.length > 0) {
          this.$message.error(`请填写完整信息: ${emptyFields.join(',')}`);
        }
      }
    },
  },
  mounted() {
    this.token = sessionStorage.getItem("token");
    this.options2 = Object.keys(TypeEnum).map(key => ({
      value: key,
      label: TypeEnum[key]
    }));
  }
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
}

.avatar-uploader :hover {
  border-color: #409EFF;
}

.release-idle-container {
  min-height: 85vh;
}

.release-idle-container-form {
  padding: 0 180px;
}

.release-idle-detiles-text {
  margin: 20px 0;
}

.release-tip {
  color: #555555;
  float: left;
  padding-right: 5px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
}

.release-idle-container-picture {
  width: 500px;
  height: 100px;
  margin: 20px 0;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader :hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-tag + .el-tag {
  margin-left: 5px;
  margin-right: 5px;
}
</style>